import { DpsGradePropertiesData } from './../../general/models/data/dpsGradePropertiesData';
import { Pipe, PipeTransform } from '@angular/core';
import { _ } from 'underscore';

@Pipe({
  name: 'plotChartSalesPipe'
})
export class PlotChartSalesPipePipe implements PipeTransform {

  transform(data: DpsGradePropertiesData, selectedProperties: any): any {

    if (!data || !selectedProperties || selectedProperties.length < 2) {
      return null;
    }
    let propertyX = selectedProperties[0];
    let propertyY = selectedProperties[1];
    let gradeProperties = data.gradeSalesProperties;
    let grades = data.grades;
    let properties = data.salesProperties;

    // Variables
    let gradesObject = [];
    let propertiesObject = [];
    let chartGrades = [];

    // Create properties array.
    _.forEach(properties, function(p) {
      propertiesObject[p.id] = p;
    });

    // Create grades array.
    _.forEach(grades, function(g) {
      gradesObject[g.substance] = g;
    });

    let minValueX;
    let maxValueX;
    let minValueY;
    let maxValueY;

    _.forEach(gradeProperties, function(g, key) {
      if (
        g.hasOwnProperty(propertyX.id) && g.hasOwnProperty(propertyY.id) &&
        g[propertyX.id][propertyX.type + 'SortValue'] && g[propertyY.id][propertyY.type + 'SortValue']
      ) {
        let xValue = parseFloat(g[propertyX.id][propertyX.type + 'SortValue']);
        let yValue = parseFloat(g[propertyY.id][propertyY.type + 'SortValue']);
        let xDisplayText = g[propertyX.id][propertyX.type + 'DisplayText'];
        let yDisplayText = g[propertyY.id][propertyY.type + 'DisplayText'];

        if (xValue || yValue) {
          minValueX = minValueX ? Math.min(minValueX, xValue) : xValue;
          maxValueX = maxValueX ? Math.max(maxValueX, xValue) : xValue;
          minValueY = minValueY ? Math.min(minValueY, yValue) : yValue;
          maxValueY = maxValueY ? Math.max(maxValueY, yValue) : yValue;
          chartGrades.push({
            substance: key.toString(),
            name: gradesObject[key].tradeName,
            propertyValueX: xValue,
            propertyValueY: yValue,
            propertyDisplayTextX: xDisplayText,
            propertyDisplayTextY: yDisplayText
          });
        }
      }
    });

    let result = {
      properties: {
        propertyX: {
          name: propertyX.name,
          unitOfMeasure: propertyX.unitOfMeasure ? propertyX.unitOfMeasure : '',
          scaleMin: minValueX === maxValueX ? (minValueX - Math.abs(minValueX * 0.1)) : (minValueX - ((maxValueX - minValueX) / 10)),
          scaleMax: minValueX === maxValueX ? (maxValueX + Math.abs(maxValueX * 0.1)) : (maxValueX + ((maxValueX - minValueX) / 10))
        },
        propertyY: {
          name: propertyY.name,
          unitOfMeasure: propertyY.unitOfMeasure ? propertyY.unitOfMeasure : '',
          scaleMin: minValueY === maxValueY ? (minValueY - Math.abs(minValueY * 0.1)) : (minValueY - ((maxValueY - minValueY) / 10)),
          scaleMax: minValueY === maxValueY ? (maxValueY + Math.abs(maxValueY * 0.1)) : (maxValueY + ((maxValueY - minValueY) / 10))
        }
      },
      grades: chartGrades
    };
    return result;
  }
}
